// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1ju8P","text":"SelectPayment_text__3IFQt","title":"SelectPayment_title__3dCCc","btn":"SelectPayment_btn__2pHIW"};